import React from 'react';
import { Link } from 'react-router-dom';
import { useContainer } from '../../hooks/useHooks/useContainer';
import { MutatingDots } from 'react-loader-spinner';

export const ProjectsCards = () => {
    const { items, loading } = useContainer('/data/projects.json');
    console.log(items);

    return loading ? (
        <div className='flex justify-center items-center spinner'>
            <MutatingDots 
                height="100"
                width="100"
                color="#570DF8"
                secondaryColor="#2F2E41"
                radius="12.5"
                ariaLabel="mutating-dots-loading"
                wrapperStyle={{}}
                wrapperClass=""
                visible={true}
            />
        </div>
    ) : (
        <>
            <div className='flex flex-wrap justify-center items-center sm:flex-col'>
                {items && items.map((item, index) => {
                    return (
                            <div className={`card w-1/2 sm:w-5/6 md:w-1/2 lg:w-1/3 xl:w-1/4 2xl:w-1/6 bg-base-100 shadow-xl border-2 border-sky-500 m-10 p-10 ${index === 2 ? 'fachari' : ''}`} key={item.id}>                            <figure className='containerImage'>
                                <img
                                    src={item.img}
                                    alt={`imagen ${item.name}`}
                                    className={`object-contain w-4/5 h-40 sm:w-4/5 h-40 md:w-4/5 h-40 lg:w-4/5 h-40 xl:w-4/5 h-72 2xl:w-4/5 h-40 ${index === 2 ? 'fachariLogo' : ''}`}


                                />
                            </figure>
                            <div className="card-body">
                                <h2 className="card-title">{item.project}</h2>
                                <h3>{item.tools}</h3>
                                <p className="h-40 lg:h-24 xl:h-40">{item.info}</p>
                                <div className="card-actions justify-end">
                                    <Link to={item.links} target="_blank" className="btn btn-primary">Deploy</Link>
                                    <Link to={item.repo} target="_blank" className="btn btn-primary">Github</Link>
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
            <div className="flex justify-center align-center pb-5">
                <Link to='/recruiter' className="btn btn-primary flex justify-self-center self-center w-1/5 ">Volver</Link>
            </div>
        </>
    );
}
